import React from 'react';
import { styled, Typography } from '@mui/material';
import Column from 'src/frontend-common/components/Column';
import { isAdmin } from 'src/utils/user';
import { getActiveCompany, setActiveCompany } from 'src/frontend-common/localstorage';
import Header from 'src/components/Header';
import { LoginBody } from 'src/style/common';
import { User } from 'src/dto/User';
import { useDispatch } from 'react-redux';
import { setUser } from 'src/redux/slices/userSlice';

interface LoginLayoutProps {
  children: React.ReactElement;
  user: User;
  adminOnly?: boolean;
}

const LoginLayout: React.FC<LoginLayoutProps> = ({ user, adminOnly, children }) => {
  const dispatch = useDispatch();
  dispatch(setUser(user));

  const activeCompanyFromStorage = getActiveCompany();
  const activeCompany = activeCompanyFromStorage && isAdmin(user) ? activeCompanyFromStorage : user.company;
  setActiveCompany(activeCompany);

  return (
    <Column>
      <Header />
      {adminOnly && !isAdmin(user) ? (
        <ForbiddenBody centered={true} grow={true}>
          <Typography variant="caption" color="error">
            You do not have the rights to view this page
          </Typography>
        </ForbiddenBody>
      ) : (
        <LoginBody grow>{children}</LoginBody>
      )}
    </Column>
  );
};

export default LoginLayout;

const ForbiddenBody = styled(Column)({
  height: '100vh',
});
